// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"9de8a260d5c0ced2","5285":"2bd0a0a51e342b6b"}[chunkId] + ".css";
};